import ChevronRightIcon from '../Icon/ChevronRightIcon.js';
import __vue_component__ from './Label.vue.js';

//
var script = {
  name: 'Node',
  components: {
    ChevronRightIcon,
    Label: __vue_component__
  },
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: [Number, String],
      default: undefined
    },
    parent: {
      type: Object,
      default: () => ({})
    },
    ancestors: {
      type: Array,
      default: () => []
    },
    expanded: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      required: true
    },
    expandLevel: {
      type: Number,
      required: true
    },
    current: {
      type: Boolean,
      default: false
    },
    hovered: {
      type: [Number, String],
      default: undefined
    },
    search: {
      type: String,
      default: '  '
    }
  },
  computed: {
    parentNodes() {
      const {
        id,
        label
      } = this.parent;
      return [...this.ancestors, ...(id ? [{
        id,
        label
      }] : [])];
    },

    isExpanded() {
      return this.hasChildNodes && this.expanded.includes(this.node.id.toString());
    },

    hasChildNodes() {
      return !!(this.node.children && this.node.children.length);
    },

    childNodes() {
      return this.getChildNodes(this.node.children);
    },

    hasMatchedChildNodes() {
      return this.search && !!this.childNodes.map(node => node.label).filter(this.isMatch).length;
    },

    isMatched() {
      return this.node.label.toLowerCase().includes(this.search.toLowerCase());
    },

    shouldBeDisplayedInSearchResults() {
      return this.search ? this.hasMatchedChildNodes || this.isMatched : true;
    },

    checked: {
      get() {
        return this.selected === this.node.id;
      },

      set(selected) {
        this.$emit('input', selected, this.parentNodes);
      }

    }
  },
  watch: {
    hasMatchedChildNodes(bool) {
      if (bool && !this.isExpanded) {
        this.$emit('toggle-expand', this.node.id);
      }
    }

  },

  mounted() {
    if (this.level < this.expandLevel && this.hasChildNodes) {
      this.$emit('toggle-expand', this.node.id);
    }

    if (this.checked) {
      this.$emit('expand', this.parentNodes.map(node => node.id));
    }
  },

  methods: {
    onSelect(id, ancestors = []) {
      this.$emit('input', id, ancestors);
    },

    getChildNodes(children = []) {
      return children.reduce((nodes, node) => {
        if (node.children) {
          return [...nodes, node, ...this.getChildNodes(node.children)];
        }

        return [...nodes, node];
      }, []);
    },

    onHover(id) {
      this.$emit('highlight', id);
    },

    onToggleExpand(id) {
      this.$emit('toggle-expand', id);
    },

    isMatch(label) {
      return label.toString().toLowerCase().includes(this.search.toLowerCase().trim());
    },

    onExpand(ids) {
      this.$emit('expand', ids);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tree/Node.vue_rollup-plugin-vue=script.js